module.exports = __webpack_public_path__ + "static/media/the-game-aflw-2026.ff9b089f.webp";